import { DonutChartData } from "@/components/visualizations/DonutChart/DonutChart";
import SingleBarChart from "@/components/visualizations/SingleBarChart.tsx/SingleBarChart";
import useTranslation from "@/hooks/useTranslation";
import { formatCarbonFootprintLabel } from "@/pages/dashboard/utils/formatters";
import Widget from "../../components/Widget/Widget";
import { IMPACT_METRICS } from "@/pages/dashboard/utils/types";
import { usePackagingImpactTotals } from "@/pages/dashboard/hooks/usePackagingImpact";

export default function PackagingImpactPerScope() {
  const { data, isLoading, isFetching } = usePackagingImpactTotals({
    metrics: [
      "carbon_footprint",
      "carbon_footprint_scope_1",
      "carbon_footprint_scope_2",
      "carbon_footprint_scope_3",
    ],
  });
  const translation = useTranslation();

  const chartData: DonutChartData = data?.packaging_impact
    ? Object.entries(data?.packaging_impact)
        .filter(([label]) => label !== "carbon_footprint" && label.includes("carbon_footprint"))
        .map(([label, value]) => ({
          label: formatCarbonFootprintLabel(label),
          value: value || 0,
        }))
        .sort((a, b) => (a.label < b.label ? -1 : 1))
    : [];

  return (
    <Widget
      title={"Packaging impact per scope"}
      tooltip={translation["dashboard"]["packaging"]["per_scope"]}
    >
      <SingleBarChart
        data={chartData}
        colorPalette="scope"
        format={IMPACT_METRICS.carbon_footprint.formatter}
        loading={isLoading || isFetching}
      />
    </Widget>
  );
}
